import { user } from '@/plugins/user';
import GptPulseService from '@/services/API/GptPulse';

import Base from '../Base';

export default class ChatMessage extends Base {
  constructor(item) {
    super(item.id, '/chat-message');

    this.owner_id = item.owner_id;
    this.text = item.message;
    this.user_name = item.user_name;
    this.user_initials = item.user_initials;
    this.created_at = item.created_at;
    this.gpt_request = item.gpt_request;
  }

  get fromMe() {
    return this.owner_id === user.data.id;
  }

  async processedMessage() {
    await GptPulseService.processedMessage(this.gpt_request.id);
    this.gpt_request.is_processed = true;
  }
}
